export default "__VITE_ASSET__D$F6ooDL__"